import React from "react";
import styles from "./index.module.css";
import { useNavigate } from "react-router-dom";
import Share from "../Share/Share";

function BlogsCard({ data }) {
  const navigate = useNavigate();

  const handleBlogNav = (slug) => {
    navigate(`/blogs/${slug}`);
  };

  const introPreview = data?.intro
    ? data.intro.length > 100
      ? `${data.intro.substring(0, 100)}...`
      : data.intro
    : "";

  const rawTag = data?.tags?.[0];
  const firstTag = rawTag
    ? typeof rawTag === "string"
      ? rawTag
      : rawTag.name
    : null;

  return (
    <div
      className={styles.card}
      onClick={() => handleBlogNav(data?.meta?.slug)}
    >
      <div className={styles.card_img}>
        <img
          src={data?.header_image_url?.url}
          alt={data?.title || "Blog post"}
        />
        {firstTag && <span className={styles.card_tag}>{firstTag}</span>}
      </div>
      <div className={styles.card_body}>
        <span className={styles.card_date}>{data?.published_date}</span>
        <h4 className={styles.card_title}>{data?.title}</h4>
        <p className={styles.card_excerpt}>{introPreview}</p>
        <div className={styles.card_footer}>
          <div className={styles.card_author}>
            {data?.authors?.[0]?.image && (
              <img
                src={data.authors[0].image}
                alt={data.authors[0].name}
                className={styles.card_avatar}
              />
            )}
            <span className={styles.card_author_name}>
              {data?.authors?.[0]?.name || "MyBurgo"}
            </span>
          </div>
          <div className={styles.card_meta_right}>
            {data?.read_time && (
              <span className={styles.card_read_time}>
                {data.read_time} min
              </span>
            )}
            <div
              onClick={(e) => e.stopPropagation()}
              className={styles.card_share}
            >
              <Share />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogsCard;
